// updateForm (webmag-database, Task 1) throws a GraphQL error whose message
// duplicates the JSON path before the actual reason (`${path} ${message}`),
// while extensions.path holds the path alone. editor-v2's describeError()
// (src/editor-v2/forms/errorPlace.ts) already prefixes a human-readable
// place, so forwarding the raw message would show the path twice. Strip the
// duplicated prefix before handing the error to the builder.
export default function stripPathPrefix(graphQLError) {
  const path = graphQLError && graphQLError.extensions && graphQLError.extensions.path;
  const message = graphQLError && graphQLError.message;
  if (path && typeof message === 'string' && message.startsWith(path)) {
    return { path, message: message.slice(path.length).trimStart() };
  }
  return { path, message };
}
